import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "@/global.scss"
import footers from '@/components/footer.vue'
const app =createApp(App)
app.use(store).use(router) .use(ElementPlus).mount('#app')
app.component('footers', footers)
